import React,{Component} from 'react';
import PbAjax from '../../lib/pbajax';
import Cache from 'c-cache';
import publicpb from '../../base/public.pb';
import SearchUserPb from './searchuser.pb';
import lang from '../../lang';
import Item from '../../profile/host-card/host-item';
import Follow from "../../component/follow";
import Loading from '../../component/loading';
import PreventParentScroll  from '../../lib/scroll/prevent-scroll';

let cache = new Cache({
    prefix: 'pcuplive'
});

class List extends Component {
    static defaultProps = {
        threshold: 100,
        keyword: ''
    }
    constructor(props) {
        super(props);
        this.state = {
            keyword: props.keyword,
            list: [],
            isEmpty: false,
            isLoading: false,
            isEnd: false
        };

        this.page = 1;
        this.pageSize = 20;
        this.pbajax = new PbAjax();

        this.fetching = false; // 加载状态加锁
        this.first = true; // 第一页
        this.dataOver = false // 数据最后一页
    }

    componentWillMount(){
        this.loadData();
    }

    componentWillReceiveProps(props) {

        let keyword = this.state.keyword;
        
        if (keyword == props.keyword) {
            return;
        }
        
        this.fetching = false; // 加载状态加锁
        this.first = true; // 第一页
        this.dataOver = false // 数据最后一页
        this.page = 1

        this.setState({
            list: [],
            isLoading: false,
            isEmpty: false,
            isEnd: false,
            keyword: props.keyword
        }, ()=>{
            this.loadData();
        });
        
    }

    componentWillUnmount() {
        this.pbajax.cancel(); 
    }

    loadData() {
        
        this.loadDataByUserName();
        // this.loadDataByUpliveCode();
    }

    loadDataByUserName(){
        this.fetching = true;

        let userToken = UP.Global.getUserToken();
       
        let headerData = {
            service: 'service',
            api: '/search/user',
            header: {
                lang: UP.Global.siteLanguage,
                userToken
            }
        };

        let requestData = new SearchUserPb.Search.User.Request({
            content: this.state.keyword,
            page: this.page,
            pageSize: this.pageSize
        });

        this.pbajax.do(headerData, requestData, (resp)=>{
            let dataWrap =  publicpb.Result.decode(resp);


            if (dataWrap.code == 1) {
                let dataAll, data = [];
                
                if (dataWrap.data.value ) {
                    dataAll = SearchUserPb.Search.User.Response.decode(dataWrap.data.value);
                    data = dataAll.infos;
                }

                let list  = this.state.list;
                
                let newState = {
                    list: [...list, ...data]
                };

                if (data.length < this.pageSize) { 
                    // 数据加载完
                    this.dataOver = true;
                    newState.isLoading = false;

                    if (this.first) {
                        if (data.length == 0) {
                            newState.isEmpty = true;
                        }
                    } else {
                        newState.isEnd = true;
                    }
                } else {
                    newState.isLoading = true;
                }

                if (this.first) {
                    // 第一页
                    this.first = false;
                }

                this.setState(Object.assign({}, this.state, newState));
            }

            this.fetching = false;            
        }, ()=>{
            this.fetching = false;
        });

        this.page = this.page + 1;
    }

    scroll(e) {
        let self = this;
        let page = this.state.page;
        let box = e.currentTarget;
        let content = this.refs.content;

        self.timer && clearTimeout(self.timer);
        self.timer = setTimeout(function() {
            if (self.dataOver) {
                return;
            }
            if (self.fetching) {
                return;
            }
            let scrollY = box.scrollTop,
                boxHeight = box.clientHeight,
                contentHeight = content.clientHeight,

                docElement = document.documentElement;
            
            //console.log(scrollY, contentHeight - boxHeight - self.props.threshold);
            if (scrollY >= contentHeight - boxHeight - self.props.threshold) {
                
                this.fetching = true;
                
                setTimeout(()=>{
                    self.loadData();
                }, 400);
            }

        }, 300);
    }

    onClick() {
        $.channel.emit('hideSearchResult');
    }

    render() {
        let list = this.state.list;
        let $list = [];
        let showList = ['username','gender', 'grade', 'upliveCode'];
        
        list.forEach((obj, idx)=>{
            
            let $btn;
            let followType;
            let temp = {};
            let followed = [1,3].indexOf(obj.followType) >= 0 ? 1 : 0;

            if (obj.uid != UP.Global.getUserId()) {
                if (followed) {
                    followType = 'followed';
                }
                $btn = (
                    <span 
                        onClick={()=>{
                            if (!cache.getCache('isRegisterRealUser')) { // 正式用户
                                $.channel.emit('login');
                                return;
                            }
                            if (followed) {
                                temp.follow.unFollow(obj.uid);
                            } else {
                                temp.follow.do(obj.uid);
                            }
                        }} 
                        className="btn" 
                        data-show={followType}>
                    </span>
                );
            }

            if ($btn) {
                temp.follow = new Follow();
                temp.follow.on('followSuccess', ()=>{
                    obj.followType = 1;
                    this.setState({
                        list
                    });
                });

                temp.follow.on('unFollowSuccess', ()=>{
                    obj.followType = null;
                    this.setState({
                        list
                    });
                });
            }
            
            $list.push((
                <Item key={obj.uid} item={obj} onClick={this.onClick} showList={showList}>
                    {$btn}
                </Item>
            ));
        });


        return (
            <div ref="content">
                <PreventParentScroll/>
                <ul>
                    { $list }
                </ul>
                { this.state.isLoading ? <Loading/> : null }
                { this.state.isEmpty ? <li className="list-tip">{lang.template('没发现此人，重新输入试试？')}</li> : null }
            </div>
        );
    }

};

export default List;



// WEBPACK FOOTER //
// ./js/header/searchuser/list-pannel.js